<script setup>
import {computed, onMounted} from "vue";
import store from "@/store";
import {couponConf} from "@/utils/config";
import JdDetails from "@/components/zxjd/jdDetails.vue";
import SqDetail from "@/components/sqwl/sqDetail.vue";
import MeLandDetail from "@/components/meland/meLandDetail.vue";
import HbwlDetailComponent from "@/components/hbwl/HbwlDetailComponent.vue";
import HklProductDetail from "@/components/hkl/HklProductDetail.vue";
import TmDetailComponent from "@/components/tm-mark/TmDetailComponent.vue";
import HiBakeDetail from "@/components/hibake/HiBakeDetail.vue";

const types = computed(() => {
  let ty = store.state.coupon
  return couponConf[ty] || {}
})
onMounted(() => {
  store.commit("getCoupon")
})
</script>

<template>
  <jd-details v-if="types.type==='jd-scal'"/>
  <sq-detail v-if="types.type==='sqwl'"/>
  <me-land-detail v-if="types.type==='meland' || types.type === 'meland-scal'" :type="types"/>
  <hbwl-detail-component v-if="types.type==='hbwl'" :type="types"/>
  <hkl-product-detail v-if="types.type==='hkl'" :type="types"/>
  <tm-detail-component v-if="types.type === 'jlx' && types.child==='tm'"/>
  <hi-bake-detail  v-if="types.type === 'hibake'"/>
</template>

<style scoped lang="less">

</style>
